
module.exports = { 
      attributes: {"title":"legals","name":"Poe-Ma Insurances","address":"8, Rue de Sébastopol - Centre-Ville, 98800 Nouméa","publication":"responsable de la publi","url":"https://url.du.site.com","mail":"email@mail.com","phone":"123456"},
    
      html: "",
     }